import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { Button } from '@/components/form/baseInputs/Button';
import { TextInput } from '@/components/form/baseInputs/TextInput';
import { DialogModal } from '@/components/modals/DialogModal/DialogModal';
interface FormExtractionPromptModalProps {
  prompt: string;
  onApply: (prompt: string) => void;
  onClose: () => void;
}
export function FormExtractionPromptModal(t0) {
  const $ = _c(17);
  const {
    prompt: initialPrompt,
    onApply,
    onClose
  } = t0;
  const [prompt, setPrompt] = useState(initialPrompt);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: 720
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onClose) {
    t2 = <Button size="sm" variant="secondary" onClick={onClose}>Cancel</Button>;
    $[1] = onClose;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onApply || $[4] !== prompt) {
    t3 = <Button size="sm" variant="primary" onClick={() => onApply(prompt)}>Apply</Button>;
    $[3] = onApply;
    $[4] = prompt;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Typography variant="body-s">This prompt applies to every question in this form and guides how information is extracted from documents.</Typography>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = event => setPrompt(event.target.value);
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== prompt) {
    t7 = <Stack spacing={2}>{t5}<TextInput id="form-extraction-prompt" label="Extraction prompt" multiline={true} rows={8} value={prompt} autoFocus={true} onChange={t6} /></Stack>;
    $[11] = prompt;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== onClose || $[14] !== t4 || $[15] !== t7) {
    t8 = <DialogModal isOpen={true} heading="Edit extraction prompt" onClose={onClose} dialogPaperSx={t1} actions={t4}>{t7}</DialogModal>;
    $[13] = onClose;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}